export default {
  ru: {
    fetch: 'Загрузка данных',
    notfound: 'По вашему запросу ничего не найдено',
    placeholder: 'Поиск',
    empty: 'Список пуст',
  },
  en: {
    // en
  },
};
